import { RefObject } from 'react';
import styled from 'styled-components';
import { InputText } from 'ui/inputs';
import { HelpText } from 'ui/formField';
import { spacing } from 'ui/theme';
import { useFieldErrorTheme } from '../common/utils';

const InputContainer = styled.div`
  margin-left: ${spacing.plusHalf};
`;

const InputWrapper = styled.div`
  display: flex;
  position: relative;
  width: 100%;
`;

type DefaultActionInputProps = {
  helpText: string;
  id: string;
  isDisabled: boolean;
  onChange: (value: string) => void;
  placeholder: string;
  value: string;
  inputRef?: RefObject<HTMLInputElement> | null;
  hasError?: boolean;
  hasWarning?: boolean;
};

export const DefaultActionInput = ({
  id,
  placeholder,
  onChange,
  value,
  isDisabled,
  helpText,
  inputRef = null,
  hasError = false,
  hasWarning = false,
}: DefaultActionInputProps) => {
  const errorTheme = useFieldErrorTheme(hasError, hasWarning);

  return (
    <InputContainer>
      <InputWrapper>
        <InputText
          hasError={hasError}
          hasIcon={false}
          errorTheme={errorTheme}
          inputRef={inputRef}
          id={id}
          data-test={id}
          placeholder={placeholder}
          onChange={onChange}
          value={value || ''}
          width="100%"
          isDisabled={isDisabled}
        />
      </InputWrapper>

      <HelpText data-test="default-action-input-help-text">{helpText}</HelpText>
    </InputContainer>
  );
};
